export default "__VITE_ASSET__BkLFcLIr__"